/* eslint-disable import/prefer-default-export */

export const CONVERSATION_UPDATE = 'CONVERSATION_UPDATE';